import { mapGetters, mapMutations } from 'vuex';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import mvtFooter from '@/common/components/mvtfooter/mvt-footer.vue';
import mvtPopSignin from '@/common/components/mvtpopsignin/mvt-popsignin.vue';
import mvtHotleadForm from '@/common/components/mvthotleadform/mvt-hotleadform.vue';
import { getRecords } from '@/common/utilities/nojq/_notification.js';

export default {
    name: 'pageAboutus',
    components: {
        mvtPopSignin,
        mvtDialogCenter,
        mvtHeader,
        mvtFooter,
        mvtHotleadForm,
    },
    inject: ['$eventBus'],
    props: ['geoInfo'],
    data() {
        return {
            hotleadOpt: {
                hotleadTitle: 'Get connected today to one of our top real estate experts.',
                hotleadType: 'ExpertConsultConsumerGlobalHomePageBottom',
                buttonText: 'Submit',
                hideProfile: true,
                showZipcode: true,
                placeholder: {
                    name: 'Full name',
                    email: 'Email',
                    phone: 'Mobile phone',
                },
            },
        };
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        assets() {
            return [
                this.glb.cdnUrl + 'images/desktop/about/aboutus-hero.jpg',
                this.glb.cdnUrl + 'images/desktop/about/aboutus-impact-left.jpg',
                this.glb.cdnUrl + 'images/desktop/about/aboutus-impact-center.jpg',
                this.glb.cdnUrl + 'images/desktop/about/aboutus-impact-right.jpg',
                this.glb.cdnUrl + 'images/desktop/about/aboutus-recognition-housingwire-2025.png',
                this.glb.cdnUrl + 'images/desktop/about/aboutus-recognition-inman-2025.jpg',
                this.glb.cdnUrl + 'images/desktop/about/aboutus-recognition-inman-2024.png',
                this.glb.cdnUrl + 'images/desktop/about/aboutus-careers.jpg',
                this.glb.cdnUrl + 'images/desktop/about/aboutus-rating-bbb-logo.svg',
                this.glb.cdnUrl + 'images/desktop/about/aboutus-rating-trustpilot-logo.png',
                this.glb.cdnUrl + 'images/desktop/about/aboutus-rating-stars.svg',
            ];
        },
        heroImage() {
            return this.assets[0];
        },
        impactImages() {
            return {
                left: this.assets[1],
                center: this.assets[2],
                right: this.assets[3],
            };
        },
        recognitionCards() {
            return [
                { title: 'HousingWire', year: '2025', text: 'Movoto recognized as a HousingWire Tech100 in 2025.', image: this.assets[4] },
                { title: 'Inman', year: '2025', text: 'Movoto awarded "The Best of Proptech Award 2025 Consumer Experience & Marketplace Innovation" by Inman.', image: this.assets[5] },
                { title: 'Inman', year: '2024', text: 'Movoto recognized as an "Inman Innovators Awards Finalist" by Inman.', image: this.assets[6] },
            ];
        },
        howMovotoWorks() {
            return [
                {
                    title: 'Take the next step',
                    text: 'When someone is ready to tour, sell, or get guidance, we help them move forward with confidence.',
                    icon: 'icon-home-heart',
                },
                {
                    title: 'Get matched locally',
                    text: 'Consumers are connected with a trusted local agent who understands their goals and market.',
                    icon: 'icon-user-chat',
                },
                {
                    title: 'Guided to closing',
                    text: 'From first conversation to closing day, consumers receive support at every key step.',
                    icon: 'icon-road-sign',
                },
                {
                    title: 'Support that stays',
                    text: 'Ongoing guidance helps keep the process clear and moving forward.',
                    icon: 'icon-hand-care',
                },
                {
                    title: 'Financing, simplified',
                    text: 'When financing is needed, buyers can be connected with a local loan officer at the right moment.',
                    icon: 'icon-home-percent',
                },
                {
                    title: 'All in one place',
                    text: 'Search, guidance, and lending come together in one connected experience.',
                    iconSvg: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
  <path d="M18.6666 22.6666V25.3333L21.3333 26.6666V28H10.6666L10.6613 26.672L13.3333 25.3333V22.6666H3.98929C3.8142 22.6656 3.64104 22.63 3.47974 22.5619C3.31843 22.4938 3.17215 22.3946 3.04927 22.2698C2.9264 22.1451 2.82935 21.9973 2.76369 21.835C2.69802 21.6727 2.66504 21.499 2.66662 21.324V4.00929C2.66662 3.26796 3.27329 2.66663 3.98929 2.66663H28.0106C28.7413 2.66663 29.3333 3.26529 29.3333 4.00929V21.324C29.3333 22.0653 28.7266 22.6666 28.0106 22.6666H18.6666ZM5.33329 5.33329V17.3333H26.6666V5.33329H5.33329Z" fill="white"/>
</svg>`,
                },
            ];
        },
        testimonials() {
            return [
                {
                    text: '"I\'ve been wanting to sell my home! After going through all the real estate apps and different companies this one actually is the best one! Movoto gets me the info I need fast and correct! I am getting all info I need fast without any snags!"',
                    name: 'Alice',
                    role: 'Recent selling customer',
                },
                {
                    text: '"I got a referral to an awesome realtor through Movoto. We initially signed up only to be able to view a house, but he was so wonderful we decided to keep working with him. Movoto was good with following up with us, and making sure our questions were answered."',
                    name: 'M. Collins',
                    role: 'Recent buying customer',
                },
            ];
        },
    },
    beforeMount() {
        this.$eventBus.$on('eventbus-login', ({ trigger }) => {
            this.showLogin(trigger);
        });
    },
    mounted() {
        let data = getRecords();
        this.updateSubscriptions(data.filter((item) => !item.disabled));
        this.$eventBus.$emit('eventbus-pageLoaded');
    },
    methods: {
        ...mapMutations('glb', ['updateSubscriptions']),
        showLogin(trigger) {
            this.$eventBus.$emit('dialog-center', { name: 'mvtAuthenticate', opt: { type: 'mvtLogin' }, trigger: trigger || this.$options.name });
        },
    },
    beforeUnmount() {
        this.$eventBus.$off('eventbus-login');
    },
};
